import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { NxButtonModule } from '@allianz/ng-aquila/button';
import { NxCardModule } from '@allianz/ng-aquila/card';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NxGridModule } from '@allianz/ng-aquila/grid';
import { NxHeadlineModule } from '@allianz/ng-aquila/headline';
import { NxSpinnerModule } from '@allianz/ng-aquila/spinner';

import { TextServiceModule } from '@ps20-frontend/text-service';

import { FormsModule } from '@angular/forms';
import { NxLinkModule } from '@allianz/ng-aquila/link';
import { NxtFieldSetModule } from '@nxt/ngx-ndbx-extensions/fieldset';
import {
  AdresseModule,
  AuslaendischeAdresseCheckboxModule,
  CommonErrorModule,
  ComparisonTableModule,
  ConfirmationModalModule,
  DesignOptionenService,
  EmptyComponentModule,
  FoldableStepperListModule,
  HinweisComponentModule,
  IfFeatureToggledModule,
  InfoIconModule,
  LeistungEigenschaftRenderModule,
  LinkModule,
  MaxNumericValueModule,
  MinNumericValueModule,
  NlfErrorModule,
  NxOptionCardModule,
  NxSelbstbeteiligungModule,
  NxShoppingCartModule,
  VermieterInputComponent,
  WarnhinweisModule,
} from '@ps20-frontend/gui-components';
import { NxRadioModule } from '@allianz/ng-aquila/radio-button';
import { FORMFIELD_DEFAULT_OPTIONS } from '@allianz/ng-aquila/formfield';
import { RegexpServiceModule } from '@ps20-frontend/regexp-service';
import { NxNumberStepperModule } from '@allianz/ng-aquila/number-stepper';
import { NxMessageModule } from '@allianz/ng-aquila/message';
import { NgReduxModule } from '@angular-redux3/store';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NxCheckboxModule } from '@allianz/ng-aquila/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NxNaturalLanguageFormModule } from '@allianz/ng-aquila/natural-language-form';
import { NxDropdownModule } from '@allianz/ng-aquila/dropdown';
import { NxInputModule } from '@allianz/ng-aquila/input';
import { NxPopoverModule } from '@allianz/ng-aquila/popover';
import { NxtIntroStageModule } from '@nxt/ngx-ndbx-extensions/intro-stage';
import { NxCircleToggleModule } from '@allianz/ng-aquila/circle-toggle';
import { NxModalModule } from '@allianz/ng-aquila/modal';
import { NxMaskModule } from '@allianz/ng-aquila/mask';
import { NxCopytextModule } from '@allianz/ng-aquila/copytext';
import { NxExpertModule } from '@allianz/ng-aquila/config';
import { OverlayModule } from '@angular/cdk/overlay';
import { NxIsoDateModule } from '@allianz/ng-aquila/iso-date-adapter';
import { GlobalActions, GlobalEventDispatcherService } from '@ps20-frontend/shop-integration-redux';
import { GlobalErrorHandler } from '@ps20-frontend/logging';
import { App } from '@ps20-frontend/frontend-models';
import { ERROR_DEFAULT_OPTIONS } from '@allianz/ng-aquila/base';
import {
  NgxCurrencyDirective,
  NgxCurrencyInputMode,
  provideEnvironmentNgxCurrency,
} from 'ngx-currency';
import { NxtInfoIconModule } from '@nxt/ngx-ndbx-extensions/info-icon';
import { NxTooltipModule } from '@allianz/ng-aquila/tooltip';
import { AllianzIconModule } from '@allianz/ngx-brand-kit/icon';

const designOptionService = new DesignOptionenService();

@NgModule({
  exports: [VermieterInputComponent],
  imports: [
    NgReduxModule,
    BrowserModule,
    RouterModule,
    CommonErrorModule,
    FormsModule,
    NxtFieldSetModule,
    NxRadioModule,
    NxButtonModule,
    NxCheckboxModule,
    NxNumberStepperModule,
    FoldableStepperListModule,
    InfoIconModule,
    BrowserAnimationsModule,
    TextServiceModule,
    RegexpServiceModule,
    NxNaturalLanguageFormModule,
    NxDropdownModule,
    NxMessageModule,
    NxGridModule,
    NxInputModule,
    NxPopoverModule,
    ConfirmationModalModule,
    NxtIntroStageModule,
    NxLinkModule,
    NxIconModule,
    NxShoppingCartModule,
    LeistungEigenschaftRenderModule,
    NxCircleToggleModule,
    NxSpinnerModule,
    NxHeadlineModule,
    NxOptionCardModule,
    NxCardModule,
    NxModalModule,
    AdresseModule,
    NxMaskModule,
    NxCopytextModule,
    EmptyComponentModule,
    LinkModule,
    HinweisComponentModule,
    ComparisonTableModule,
    NxExpertModule,
    AllianzIconModule,
    NlfErrorModule,
    WarnhinweisModule,
    OverlayModule,
    NxIsoDateModule,
    NxSelbstbeteiligungModule,
    IfFeatureToggledModule,
    AuslaendischeAdresseCheckboxModule,
    MinNumericValueModule,
    MaxNumericValueModule,
    NgxCurrencyDirective,
    NxtInfoIconModule,
    NxTooltipModule,
    VermieterInputComponent,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de',
    },
    GlobalActions,
    { provide: ErrorHandler, useValue: new GlobalErrorHandler(App.RS_VERMIETUNG) },
    {
      provide: 'globalEventDispatcherRef',
      useClass: GlobalEventDispatcherService,
    },
    {
      provide: FORMFIELD_DEFAULT_OPTIONS,
      useFactory: () => designOptionService.getCurrentDesignOptions().formfieldOptions,
    },
    {
      provide: ERROR_DEFAULT_OPTIONS,
      useFactory: () => designOptionService.getCurrentDesignOptions().errorOptions,
    },
    CurrencyPipe,
    provideEnvironmentNgxCurrency({
      align: 'left',
      allowNegative: true,
      allowZero: true,
      decimal: ',',
      precision: 0,
      prefix: '',
      suffix: '',
      thousands: '.',
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Natural,
    }),
  ],
})
export class VermieterInputModule {}
